export const TOP_ROWS = 12;

export function toRedzoneRows(stats) {
  return stats.map((stat) => ({
    ...stat,
    player: `${stat.player.firstName} ${stat.player.lastName}`,
    position: stat.player.position ? stat.player.position.name : "",
    logoSrc: stat.player.team ? stat.player.team.logoSrc : null,
  }));
}

export function toSplitRows(splits) {
  return splits
    .filter((split) => split.totalPlays > 0)
    .map((split) => ({
      id: split.id,
      abbreviation: split.team.abbreviation,
      passPct: Number(((split.passes / split.totalPlays) * 100).toFixed(1)),
      rushPct: Number(((split.rushes / split.totalPlays) * 100).toFixed(1)),
    }))
    .sort((a, b) => b.passPct - a.passPct);
}
